import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import global_en from './translations/en/global.json';
import global_sk from './translations/sk/global.json';
import global_cz from './translations/cz/global.json';

import i18next from 'i18next';
import App from './App';

import './assets/fonts/fonts.css';
import './css/root.css';
import './css/main.css';
import './css/tab_menu.css';
import './css/user_menu_override.css';
import './css/typing.css';

import { I18nextProvider } from 'react-i18next';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";
import { NotificationProvider } from './context/NotificationContext';
import {PublicClientApplication} from "@azure/msal-browser";
import config from "./config/configJS";
import { DEFAULT_LANG, SUPPORTED_LANGS, dropLegacyLangCookie, initialLang, isoLang } from './services/language';

// Predvolená slovenčina; vlastná voľba z prehliadača (jazyk z účtu sa doplní po prihlásení — AuthProvider)
const startLang = initialLang();
dropLegacyLangCookie();
i18next.init({
  interpolation: { escapeValue: true },
  lng: startLang,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: SUPPORTED_LANGS,
  resources: {
    en: { global: global_en },
    sk: { global: global_sk },
    cz: { global: global_cz }
  },
});
document.documentElement.lang = isoLang(startLang);

// MSAL sa mountuje vždy (5x useMsal to vyžaduje), ale reálne sa použije len keď je
// Azure prihlásenie zapnuté (rieši BE /api/auth/Config). Prázdny clientId by zhodil
// PublicClientApplication pri boote -> doplníme bezpečný placeholder GUID.
const adConfig = config.adConfig || {};
const msalInstance = new PublicClientApplication({
  auth: {
    ...adConfig,
    clientId: adConfig.clientId || "00000000-0000-0000-0000-000000000000",
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

console.log('msalInstance', msalInstance);
root.render(
  <BrowserRouter basename="/">
    <I18nextProvider i18n={i18next}>
      <MsalProvider instance={msalInstance}>
      <AuthProvider>
      <NotificationProvider>
        <Routes>
          <Route path="/*" element={ <App/> } />
        </Routes>     
        </NotificationProvider>
      </AuthProvider>
      </MsalProvider>
    </I18nextProvider>   
  </BrowserRouter>
);

reportWebVitals();
